import { z } from 'zod';

export const APP_NATIVE_VARIABLE_TYPES = ['client', 'proposal', 'user'] as const;
export type AppNativeVariableType = (typeof APP_NATIVE_VARIABLE_TYPES)[number];

const appNativeVariableV2Schema = z.object({
  name: z.string(),
  friendlyName: z.string(),
  type: z.enum(APP_NATIVE_VARIABLE_TYPES),
  value: z.union([z.string(), z.number()]).nullable(),
});

export const appNativeVariablesV2ResponseSchema = z.object({
  client: z.array(appNativeVariableV2Schema),
  proposal: z.array(appNativeVariableV2Schema),
  user: z.array(appNativeVariableV2Schema),
});

export type AppNativeVariablesV2Response = z.infer<typeof appNativeVariablesV2ResponseSchema>;
